export default "__VITE_ASSET__BSwu5GaS__"